module.exports = __webpack_public_path__ + "static/img/cbf-logo.6ea81fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cbf-logo.png
// module id = cmeq
// module chunks = 94